import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";
import { WSQueryCache } from "@ws-react-query";
import { QUERY_BACKGROUND_CHECKS_REQUEST } from "../../../../../../query/backgroundChecks/queries/useQueryBackgroundChecksRequest";

export const getBackgroundChecksRequestFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): IBackgroundCheckRequestResponse | undefined => {
  return WSQueryCache.getQueryData<IBackgroundCheckRequestResponse>([
    QUERY_BACKGROUND_CHECKS_REQUEST,
    requirement.dataSourceId
  ]);
};
